import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';

import { getLoadingIntervals } from '@core/dashboard/components/DashboardContent/GameCast/GameCastLoader/helper';
import { useMytaverseEvent } from '@core/dashboard/providers';

import { useStyles } from './styles';
import { withTranslation, WithTranslation } from 'react-i18next';

interface ILoaderText extends WithTranslation {
  step: number;
}

const LoaderText = ({ step, t: translate }: ILoaderText) => {
  const classes = useStyles();

  const { currentEvent } = useMytaverseEvent();

  const { gameliftInitTime, ueInitTime, delay } = getLoadingIntervals(
    currentEvent?.settings?.timerLoadingTimeMins || null,
  );

  const [time, setTime] = useState(() => {
    if (step === 1) {
      return gameliftInitTime + ueInitTime + delay;
    } else if (step === 2) {
      return ueInitTime + delay;
    } else {
      return delay;
    }
  });

  useEffect(() => {
    const timer = setInterval(() => {
      setTime((prevTime) => {
        if (prevTime <= 0) {
          clearInterval(timer);
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    let newTime: number;
    if (step === 1) {
      newTime = gameliftInitTime + ueInitTime + delay;
    } else if (step === 2) {
      newTime = ueInitTime + delay;
    } else {
      newTime = delay + 1;
    }
    setTime((prevState) => (prevState >= newTime ? newTime : prevState));
  }, [step, delay]);

  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
  };

  if (time <= 0) {
    return (
      <Box sx={classes.progressTextWrap}>
        <Typography sx={classes.progressText}>
          {translate('loading.loadingTimeTooLong')}
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={classes.progressTextWrap}>
      <Typography sx={classes.progressText}>
        {translate('loading.loadingTime')}
      </Typography>
      <Typography sx={classes.timer}>{formatTime(time)}</Typography>
    </Box>
  );
};

export default withTranslation()(LoaderText);
